import React, { useState, useEffect } from 'react';
import { EuiLoadingSpinner, EuiBasicTable } from '@elastic/eui';
import { convertEpochToDate } from '../../../utils';
import { ErrorDisplay } from '../../../components/ErrorDisplay';
import { renderCreatorIdentityServicePrinciple } from '../../../utils/JsxUtils';
import { useSdpdsReadOnlyOperation } from '../../../hooks/useSdpdsReadOnlyOperation';

const columns = [
  {
    field: 'property',
    name: 'property',
  },
  {
    field: 'value',
    name: 'value',
    render: (item) => {
      if (typeof item === 'function') return item();
      return item;
    },
  },
];

export const ComponentDetails = (props) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(null);

  const { data, error } = useSdpdsReadOnlyOperation({
    operation_name: "DescribeComponent",
    payload: {
      stackName: props.stackName,
      componentName: props.componentName,
      componentScopeDefinition: {
        componentScope: props.componentScope,
        componentScopeValue: props.componentScopeValue,
      },
    }
  });

  const updateResponse = (response) => {
    const newItems = [];
    const {
      component: {
        auditProperties: {
          createdBy,
          creationTime,
          lastModificationTime,
          lastModifiedBy,
        },
        componentName,
        componentProperties: { parentComponent, requiresRestart },
        componentScopeDefinition: { componentScope, componentScopeValue },
        componentType,
        isDeprecated,
        stackName,
      },
    } = response;
    newItems.push({ property: 'Stack', value: stackName });
    newItems.push({ property: 'Component Name', value: componentName });
    newItems.push({ property: 'Component Type', value: componentType });
    newItems.push({ property: 'Component Scope', value: componentScope || '-' });
    newItems.push({
      property: 'Component Scope Value',
      value: componentScopeValue || '-',
    });
    newItems.push({
      property: 'Created By',
      value: renderCreatorIdentityServicePrinciple(createdBy),
    });
    newItems.push({
      property: 'Creation Time',
      value: convertEpochToDate(creationTime),
    });
    newItems.push({ property: 'Parent Component', value: parentComponent || '-' });
    newItems.push({
      property: 'Requires Restart',
      value: String(requiresRestart),
    });
    newItems.push({ property: 'Is Deprecated', value: String(isDeprecated) });
    newItems.push({ property: 'Last Modified By', value: lastModifiedBy });
    newItems.push({
      property: 'Last Modified Time',
      value: convertEpochToDate(lastModificationTime),
    });
    setItems(newItems);
  };

  useEffect(() => {
    if (error) {
      setIsError(error);
      setIsLoading(false);
    } else if (data?.sdpdsReadOnlyOperation) {
      updateResponse(data.sdpdsReadOnlyOperation);
      setIsLoading(false);
    }
  }, [data, error]);

  if (isLoading) {
    return <EuiLoadingSpinner size="l" id="loadingSpinner" />;
  } else if (isError) {
    return <ErrorDisplay message={isError} />;
  }
  return <EuiBasicTable columns={columns} items={items} />;
};
